export default "__VITE_ASSET__DQJjACZZ__"